import React, { Component } from 'react'
import Moment from 'moment'
import classnames from 'classnames'
import { Link } from 'react-router-dom'
import { NotAvailable } from '@myxplor/ui'

import { conditionalLink } from '../../conditional-link'
import { dragSourceWrapper } from '../../drag-drop'
import { recordIsDraggable, DragHandle } from './draggable'
import MatchPill from './match-pill'

const dob = ({ dob }) => (
  <li>
    <dt>
      <abbr title="Birthday">DOB</abbr>
    </dt>
    <dd>
      {dob ? (
        <time dateTime={dob}>{Moment(dob, 'YYYY-MM-DD').format('Do MMM YYYY')}</time>
      ) : (
        <NotAvailable name="Birthday" />
      )}
    </dd>
  </li>
)

const crn = ({ crn }) => (
  <li>
    <dt>
      <abbr title="Care Registration Number">CRN</abbr>
    </dt>
    <dd>{crn ? crn : <NotAvailable name="CRN" />}</dd>
  </li>
)

const defaultState = {
  merging: false,
  hidden: false,
}

class CareEnrolmentItem extends Component {
  constructor(props) {
    super(props)
    this.state = props.merge || defaultState
  }

  mergePending() {
    this.setState({
      merging: true,
    })
  }

  mergeFailed() {
    this.setState(defaultState)
  }

  mergeCompleted() {
    this.setState({
      hidden: true,
    })
  }

  render() {
    if (this.state.hidden) {
      return null
    } else {
      const { record, path, selected = false, connectDragSource } = this.props

      return dragSourceWrapper(
        connectDragSource,
        recordIsDraggable(record),
        <div
          title={record.inactive ? 'This record is inactive' : null}
          className={classnames({
            listItemContent: true,
            inactiveRecord: record.inactive,
            draggable: recordIsDraggable(record),
          })}>
          <div>
            {conditionalLink(
              !selected,
              <Link to={path}>
                <div className="listItemContent--heading">
                  {record.first_name} {record.last_name}
                </div>
              </Link>
            )}
            <dl className="listItemContent--details">
              {dob(record)}
              {crn(record)}
            </dl>
          </div>

          <div className="listItemContent--indicators">
            <MatchPill status={record.status} />
            <DragHandle record={record} selected={selected} merging={this.state.merging} />
          </div>
        </div>
      )
    }
  }
}

export default CareEnrolmentItem



// WEBPACK FOOTER //
// ./src/care-enrolments/list-item/view.jsx